import React, { useState, useEffect } from "react";
import {
  ButtonHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  SubtitlePageHLPure,
  CheckBoxDownHLPure
} from "../../../pures";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { profileIconDefault } from "../../../../assets/logos/icons";
import "./user-administration-enterprise-assign.view.css";

const UserAdministrationEnterpriseView = ({
  hideShowDetails,
  companiesRolesByUser,
  rolesBySignatureProfile,
  saveNewCompaniesRolesForUser,
  selectedUser,
  token,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  allPermissions
}) => {
  const [listOptions, setListOptions] = useState([
    // { id: 0, name: "Sin acceso" },
  ]);
  // const [company, setCompany] = useState(
  //   listOptions[0].name
  // );
  const [companiesRolesByUserState, setCompaniesRolesByUserState] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    setOptionsOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setOptionsOrder = () => {
    rolesBySignatureProfile.rolesLevelsBoveda.map((rolContrato) => {
      if (rolContrato.name === "Sin acceso bóveda") {
        rolContrato.name = rolContrato.name.substr(0, 10);
      }
      return rolesBySignatureProfile;
    });
    listOptions.push(...rolesBySignatureProfile.rolesLevelsBoveda);
    setListOptions(listOptions);
  };

  useEffect(() => {
    if (Object.keys(companiesRolesByUser).length !== 0) {
      setCompanyByUserState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesRolesByUser, allPermissions]);

  const setCompanyByUserState = () => {
    console.log(allPermissions)
    let finalArr = companiesRolesByUser.map((item) => {
        if(item.roleName === "Administrador Bóveda Digital") item.roleName = "Administrador"
        let permisos = allPermissions.find((role) => role.roleId === item.roleId)
        if(permisos) item.permissions = permisos.permissions
        return item
    });

    setCompaniesRolesByUserState(finalArr);
  };
  const handleDropDownChange = (e, dropdownCompany) => {
    let selectedRolId = listOptions.filter(
      (option) => option.id === Number(e.target.value)
    );
    // .filter((option) => option.id === e.target.value)
    // .reduce((obj) => obj).id;

    let updateRolesCompaniesState = companiesRolesByUserState.map((company) =>{
      if(company.nameCompany === dropdownCompany.nameCompany){
        let permisos = allPermissions.find((role) => role.roleId === Number(e.target.value))
        company.roleId = Number(e.target.value)
        company.roleName = selectedRolId.roleName
        company.permissions = (permisos) ? permisos.permissions : company.permissions
      }
      return company
    });

    setCompaniesRolesByUserState(updateRolesCompaniesState);
  };

  const onSaveNewCompaniesRoles = () => {
    let res = companiesRolesByUserState.map((item) => {
      return { idCompany: item.idCompany, role: item.roleId };
    });

    let body = {
      email: selectedUser.email,
      userRoles: res,
    };

    saveNewCompaniesRolesForUser(token, body);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationEnterpriseAssignView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="userAdministrationEnterpriseAssignView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== "" ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== "" &&
                  selectedUser.secondLastName !== "")
                ? `${t("userAdministrationEnterpriseView.title.companies.to")} ${selectedUser.name}`
                : t("userAdministrationEnterpriseView.title.assign.companies")
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="UserAdministrationEnterpriseAssignView-body"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationEnterpriseAssignView-form"
          >
            {companiesRolesByUserState &&
              companiesRolesByUserState.length &&
              companiesRolesByUserState.map((company) => {
                return (
                  <>
                    <DropDownBtnHLPure
                      labelDropDown={company.nameCompany}
                      optionsDropDown={listOptions}
                      onDropDownChange={(e) => handleDropDownChange(e, company)}
                      optionsValue={company.roleId}
                      valueItem={"id"}
                      nameOption={"name"}
                      flex
                    />
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="userAdministrationEnterpriseAssignView-checkboxGrid"
                    >
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.consult")}
                        checkedState={company.permissions.wacth}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.contracts")}
                        checkedState={company.permissions.contratcs}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.metadata")}
                        checkedState={company.permissions.editMetadata}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.play")}
                        checkedState={company.permissions.play}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.print")}
                        checkedState={company.permissions.print}
                      />
                      <br></br>
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.download")}
                        checkedState={company.permissions.download}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.share")}
                        checkedState={company.permissions.share}

                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.send")}
                        checkedState={company.permissions.sendMail}

                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.upload")}
                        checkedState={company.permissions.upload}
                      />

                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.alerts")}
                        checkedState={company.permissions.alerts}
                      />
                    </Grid>
                  </>
                );
              })}

            {/* {companiesRolesByUserState &&
              companiesRolesByUserState.length &&
              companiesRolesByUserState.map((company) => {
                return (
                  <div
                    className="UserAdministrationEnterpriseView-block1"
                    key={company.idCompany}
                  >
                    <label
                      htmlFor={company.nameCompany}
                      className="UserAdministrationEnterpriseView-label"
                    >
                      {company.nameCompany}
                    </label>
                    <span className="UserAdministrationEnterpriseView-dropdown-wrapper">
                      <select
                        className="UserAdministrationEnterpriseView-select"
                        onChange={handleDropDownChange}
                        id={company.nameCompany}
                        value={company.roleName}
                      >
                        {listOptions.map((option) => (
                          <option
                            value={option.name}
                            key={option.id}
                            className="UserAdministrationEnterpriseView-dropdown-option"
                          >
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                );
              })} */}
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationEnterpriseAssignView-btnGroup"
          >
            <Grid className="userAdministrationEnterpriseAssignView-spaceBtns">
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </Grid>
            <ButtonHLPure
              primary
              nameBtn={t("button.save")}
              onClickBtn={onSaveNewCompaniesRoles}
            />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={message}
          />
        </Grid>

        {/* <SubtitlePageHLPure
          subtitle={`Empresas para ${selectedUser.name}`}
          imgProfile={selectedUser.profilePicture}
        /> */}
        {/* <Grid container className="UserAdministrationEnterpriseView-body">
          {companiesRolesByUserState &&
            companiesRolesByUserState.length &&
            companiesRolesByUserState.map((company) => {
              return (
                <div
                  className="UserAdministrationEnterpriseView-block1"
                  key={company.idCompany}
                >
                  <label
                    htmlFor={company.nameCompany}
                    className="UserAdministrationEnterpriseView-label"
                  >
                    {company.nameCompany}
                  </label>
                  <span className="UserAdministrationEnterpriseView-dropdown-wrapper">
                    <select
                      className="UserAdministrationEnterpriseView-select"
                      onChange={handleDropDownChange}
                      id={company.nameCompany}
                      value={company.roleName}
                    >
                      {listOptions.map((option) => (
                        <option
                          value={option.name}
                          key={option.id}
                          className="UserAdministrationEnterpriseView-dropdown-option"
                        >
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
              );
            })}
        </Grid> */}

        {/* <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="UserAdministrationEnterpriseView-buttonContainer"
        >
          <Grid className="userAdministrationDisableUserView-spaceBtns">
            <ButtonHLPure
              nameBtn={"Regresar"}
              onClickBtn={
                showDetailComponent
                  ? toggleShowDetailComponent
                  : hideShowDetails
              }
            />
          </Grid>
          <ButtonHLPure
            primary
            nameBtn={"Guardar"}
            onClickBtn={onSaveNewCompaniesRoles}
          />
        </Grid> */}
      </>
    </Grid>
  );
};

export default UserAdministrationEnterpriseView;
